import { render, staticRenderFns } from "./BonusPayments.vue?vue&type=template&id=77b4370f"
import script from "./BonusPayments.vue?vue&type=script&lang=js"
export * from "./BonusPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports